import { render, staticRenderFns } from "./SliderSetting.vue?vue&type=template&id=fa132bce&scoped=true&"
import script from "./SliderSetting.vue?vue&type=script&lang=js&"
export * from "./SliderSetting.vue?vue&type=script&lang=js&"
import style0 from "./SliderSetting.vue?vue&type=style&index=0&id=fa132bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa132bce",
  null
  
)

export default component.exports